import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { CSSObjectWithLabel } from 'react-select';
import Select from 'react-select/creatable';
import { useDebounceValue } from '../../hooks/useDebounceValue';

export type GroupTagUpdateItem = {
  id: number | string;
  name: string;
};

type Props = {
  onSearch: (query: string) => Promise<GroupTagUpdateItem[]>;
  onChange: (items: GroupTagUpdateItem[]) => void;
  value?: GroupTagUpdateItem[];
  defaultValue?: GroupTagUpdateItem[];
};

type Option = GroupTagUpdateItem;

export const GroupTagSelect = (props: Props) => {
  const [input, setInput] = useState('');

  const debouncedValue = useDebounceValue(input, 200);

  const searchQuery = useQuery({
    queryKey: ['group-tags-search', debouncedValue],
    queryFn: () => props.onSearch(debouncedValue),
    enabled: true,
  });

  return (
    <Select<Option, true>
      isMulti
      options={searchQuery.data}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 10 }) as CSSObjectWithLabel,
        menu: base => ({ ...base, zIndex: 10 }) as CSSObjectWithLabel,
      }}
      getOptionLabel={x => x.name}
      getOptionValue={x => x.id?.toString()}
      menuPortalTarget={document.body}
      formatCreateLabel={input => `Create "${input}"`}
      isValidNewOption={input => input.length > 2}
      inputValue={input}
      getNewOptionData={input => ({ id: input, name: input })}
      isLoading={searchQuery.isLoading}
      onChange={newVal => props.onChange([...newVal])}
      value={props.value}
      defaultValue={props.defaultValue}
      onInputChange={setInput} />
  );
};
